<template>
  <div class="administrat mainContent">
    <div v-if="!showMore" class="main_content">
      <div class="query-box search">
        <div class="date_search">
          <!-- 查询条件 -->
          <SearchDate @handleSearch="handleSearch" :searchDate="currenNode" ref="searchDate"></SearchDate>
        </div>
        <!-- 机构树搜索 -->
        <div class="searchTree">
          <SearchTree @currentNode="currentNode"></SearchTree>
        </div>
        <el-button type="primary" class="serachBtn" size="small" @click="handleChild">
          {{ $t('query') }}
        </el-button>
      </div>
      <div class="main-static">
        <!--  左侧 -->
        <transition name="moveL">
          <div class="left-person" v-show="flag2" key="person1">
            <!-- 人员活跃度统计 -->
            <div class="content_box active_person">
              <div class="record">
                <div class="title_box">
                  <div class="new_title">{{ $t('Personnelactivitystatistics') }}</div>
                </div>
                <div
                  class="check_more"
                  v-if="showCheckBtn.personShow"
                  @click="checkMore(mainTitle.activeTitle, '', 'active')"
                >
                  {{ $t('SeeMore') }}>
                </div>
              </div>
              <div class="person_status">
                <PersonAtivity
                  :personHas="showMore"
                  @changePersonMore="changePersonMore"
                  :currenNode="currenNode"
                ></PersonAtivity>
              </div>
            </div>
            <!-- 人员活跃时段统计 -->
            <div class="content_box healty_statu">
              <div class="title_box">
                <div class="new_title">{{ $t('StatisticsPersonnelPeriods') }}</div>
              </div>
              <ActivePeriod :currenNode="currenNode"></ActivePeriod>
            </div>
          </div>
        </transition>

        <!--  右侧 -->

        <div class="right_li">
          <!-- 人员活动距离统计 -->
          <div class="content_box ">
            <div class="record">
              <div class="title_box">
                <div class="new_title">{{ mainTitle.distanceTitle }}</div>
              </div>
              <div
                class="check_more"
                v-if="showCheckBtn.traceShow"
                @click="checkMore(mainTitle.distanceTitle, traceData, '3dbar')"
              >
                {{ $t('SeeMore') }}>
              </div>
            </div>
            <AlarmStatu class="alarm_statu" :traceData="traceData" :unit="traceData.unit"></AlarmStatu>
          </div>
          <!-- 人员音视频记录 -->
          <div class="content_box ">
            <div class="record">
              <div class="title_box">
                <div class="new_title">{{ mainTitle.audioFrequency }}</div>
              </div>
              <div
                class="check_more"
                v-if="showCheckBtn.vedioShow"
                @click="checkMore(mainTitle.audioFrequency, barData, 'bar')"
              >
                {{ $t('SeeMore') }}>
              </div>
            </div>
            <div class="alarm_statu">
              <!-- <img class="loading_img" src="@/icon/newBg/loading.gif" alt=""> -->
              <PersonMedia :barData="barData"></PersonMedia>
            </div>
          </div>
        </div>
      </div>
      <transition name="moveR">
        <div class="content_box person-static" v-show="flag2" key="person2">
          <div class="record">
            <div class="title_box">
              <div class="new_title">{{ $t('attendanceStatistics') }}</div>
            </div>
            <div class="attendance-time">
              <!-- <span class="time-title">{{ $t('attendanceTime') }} ：</span> -->
              <el-date-picker
                v-model="StaticSearchTime"
                :placeholder="$t('startDate')"
                type="date"
                value-format="yyyy-MM-dd"
                popper-class="date-picker-blue-hw"
                :clearable="true"
              >
              </el-date-picker>
            </div>
            <div class="check_more" @click="checkMore($t('attendanceStatistics'), '', 'static')">
              {{ attenceStaticShow ? $t('SeeMore') : $t('exportData') }}>
            </div>
          </div>
          <!-- 考勤统计组件 -->
          <personStatic
            :currenNode="currenNode"
            :StaticSearchTime="StaticSearchTime"
            ref="attendanceStatic"
            @showMoreStatic="showMoreStatic"
          ></personStatic>
        </div>
      </transition>
    </div>
    <div v-if="showMore" class="main_content">
      <CheckMore
        @backHome="backHome"
        :moreTitle="moreTitle"
        :type="echartType"
        :echartData="echartData"
        :currenNode="currenNode"
        :StaticSearchTime="StaticSearchTime"
      ></CheckMore>
    </div>
  </div>
</template>

<script>
// 依赖组件
import AlarmStatu from '@/views/new-home/AlarmStatu.vue'
import PersonnelAccess from '@/views/new-home/PersonnelAccess.vue'
import ActivePeriod from '@/views/new-home/ActivePeriod.vue'
import PersonMedia from '@/views/new-person/PersonMedia.vue'
import PersonAtivity from '@/views/new-person/PersonAtivity.vue'
import PersonInOut from '@/views/new-person/PersonInOut.vue'
import SearchDate from '@/views/new-home/SearchDate.vue'
import SearchTree from '@/views/new-home/SearchTree.vue'
import CheckMore from '@/views/new-more/CheckMore.vue'
import personStatic from '@/views/new-person/PersonAttendanceStatic.vue'
// 依赖工具
import { nowDate, formatDate, addDay, beforeMonthDate } from '@/util/date'
import { getStatistics, allFullNames, ouMapIncludeChildren, getStatisTrace } from '@/api/log'
export default {
  data() {
    return {
      // 显示动画
      flag2: false,
      // 查看更多的 框的标题，方便传值
      mainTitle: {
        distanceTitle: this.$t('Personnelactivitydistance'),
        audioFrequency: this.$t('Personnelvideopicturerecord'),
        accessTitle: this.$t('Realtimerecordpersonnel'),
        personnel: this.$t('PersonnelAccessManagement'),
        activeTitle: this.$t('Personnelactivitystatistics'),
      },
      // 当前机构信息
      currenNode: {
        id: '154827590683746304',
        startTime: beforeMonthDate() + ' 00:00:00',
        endTime: nowDate() + ' 23:59:00',
      },
      // 音视频柱状图数据
      barData: {
        barId: 'mediaId',
        unit: '',
        videoUnit: this.$t('MinutesVideo'),
        picUnit: this.$t('piecesPicture'),
        xData: [],
        barEchartData: [],
        barAudioData: [],
        allXData: [],
        allBarData: [],
        allAudioData: [],
        color: ['#35E878', '#FFCD1F'],
        lineName: this.$t('videoS'),
        barName: this.$t('pictureS'),
      },
      // 人员活动距离统计
      traceData: {
        distantData: [],
        traceXAxis: [],
        allData: [],
        allXData: [],
        unit: 'm',
      },
      // 某个机构下 所有子机构数据
      mapIncludeChild: [],
      // 某个机构下 所有用户数据
      userNames: [],
      userMap: null,
      activeData: [],
      personMore: false,
      // 显示更多的内容弹窗
      showMore: false,
      // 更多的标题传值
      moreTitle: '',
      echartType: '3dbar',
      echartData: [],
      // 显示 ‘更多’按钮 {音视频，人员活动距离，人员活跃度统计}
      showCheckBtn: { vedioShow: false, traceShow: false, personShow: false },
      StaticSearchTime: nowDate(),
      attenceStaticShow: false,
    }
  },
  components: {
    PersonnelAccess,
    ActivePeriod,
    AlarmStatu,
    PersonMedia,
    PersonAtivity,
    SearchDate,
    SearchTree,
    CheckMore,
    PersonInOut,
    personStatic,
  },
  methods: {
    // 日期子组件触发 处理事件
    handleChild() {
      this.$refs.searchDate.searchData()
    },
    // 考勤统计 是否显示更多按钮
    showMoreStatic(type) {
      console.log(type)
      this.attenceStaticShow = type
    },
    // 人员活跃度 是否显示更多按钮
    changePersonMore(type) {
      this.showCheckBtn.personShow = type
    },
    // 返回
    backHome() {
      this.showMore = false
    },
    // 查看更多
    checkMore(title, data, type) {
      if (!this.attenceStaticShow && type === 'static') {
        // 导出数据
        this.$refs.attendanceStatic.exportStatic()
      } else {
        this.moreTitle = title
        this.echartData = data
        this.echartType = type
        this.showMore = true
      }
    },
    // 结构树当前节点（用户头盔）
    currentNode(item) {
      this.currenNode.id = item.id
      this.currenNode = Object.assign({}, this.currenNode)
      if (!this.userMap) {
        this.getAllFullNames(true)
      } else {
        // 执行查询当前租户的数据
        for (let user in this.userMap) {
          this.userMap[user]['distance'] = 0
          this.userMap[user]['video'] = 0
          this.userMap[user]['photo'] = 0
        }
        this.getTraceData()
        this._getStatistics()
      }
    },
    // 人员检出管理 是否显示查看更多
    personelMore(val) {
      this.personMore = val
    },
    // 日期子组件触发 处理事件
    handleSearch(val) {
      this.currenNode.startTime = val.logTimestampBegin
      this.currenNode.endTime = val.logTimestampEnd
      this.currenNode = Object.assign({}, this.currenNode)
      if (!this.userMap) {
        this.getAllFullNames(true)
      } else {
        for (let user in this.userMap) {
          this.userMap[user]['distance'] = 0
          this.userMap[user]['video'] = 0
          this.userMap[user]['photo'] = 0
        }
        this.getTraceData()
        this._getStatistics()
      }
    },
    // 获取当前机构下 所有用户
    getAllFullNames(getData = false) {
      this.userMap = {}
      allFullNames(this.currenNode).then(res => {
        if (res.state === 0) {
          this.userNames = res.data
          if (res.data && res.data.length > 0) {
            for (let user of res.data) {
              if (!this.userMap[user.id + '']) {
                this.userMap[user.id + ''] = {}
              }
              this.userMap[user.id + '']['name'] = user.name
              this.userMap[user.id + '']['distance'] = 0
              this.userMap[user.id + '']['video'] = 0
              this.userMap[user.id + '']['photo'] = 0
            }
          }
          if (getData) {
            this.getTraceData()
            this._getStatistics()
          }
        }
      })
    },
    // 获取当前机构下 所有子机构
    getMapIncludeChild() {
      ouMapIncludeChildren(this.currenNode).then(res => {
        if (res.state === 0) {
          this.mapIncludeChild = res.data
        }
      })
    },
    // 轨迹统计查询接口
    getTraceData() {
      // logDateBegin: 年-月-日 格式
      let param = {
        ouId: this.currenNode.id,
        logDateBegin: formatDate(this.currenNode.startTime),
        logDateEnd: formatDate(this.currenNode.endTime),
      }
      // 结束时间加一天
      param.logDateEnd = addDay(param.logDateEnd, 1)
      // 清空原数据
      this.traceData.unit = 'm'
      this.traceData.allXData = []
      this.traceData.allData = []
      this.traceData.traceXAxis = []
      this.traceData.distantData = []
      // 请求 人员活动距离统计数据
      getStatisTrace(param).then(res => {
        if (res.state === 0) {
          this.traceData = {
            distantData: [],
            traceXAxis: [],
            allData: [],
            allXData: [],
            unit: 'm',
          }
          // 按用户显示轨迹数据
          if (res.value.helmetTraceMap) {
            // 循环机构判断数据里是否有该机构的数据
            for (let ouId in res.value.helmetTraceMap) {
              let userStatistics = res.value.helmetTraceMap[ouId]
              for (let userId in userStatistics) {
                let userData = userStatistics[userId]
                let userTimeSecond = Number(userData.distance)
                let traceSecond = userTimeSecond.toFixed(2)
                if (!this.userMap[userId + '']) {
                  this.userMap[userId + ''] = {}
                  this.userMap[userId + '']['distance'] = 0
                }
                this.userMap[userId + '']['distance'] = traceSecond
              }
            }
            let distanceArr = []
            for (let userId in this.userMap) {
              if (this.userMap[userId]['distance'] > 0) {
                distanceArr.push(this.userMap[userId])
              }
            }
            // 数据排序
            distanceArr.sort(function(a, b) {
              return b.distance - a.distance //b-a为降序
            })
            this.traceData.allXData = []
            this.traceData.allData = []
            for (let subMedia of distanceArr) {
              if (subMedia.distance && subMedia.distance > 0) {
                // 距离大于 10000 m 化单位 为km
                if (distanceArr[0].distance > 10000) {
                  this.traceData.allXData.push(subMedia.name)
                  this.traceData.allData.push((subMedia.distance / 1000).toFixed(1))
                  this.traceData.unit = 'km'
                } else {
                  this.traceData.allXData.push(subMedia.name)
                  this.traceData.allData.push(subMedia.distance)
                }
              }
            }
            this.traceData.traceXAxis = []
            this.traceData.distantData = []
            // 页面做数据截取 （页面显示六条更多数据可查看更多）
            if (this.showMore === false && this.traceData.allXData.length > 6) {
              this.traceData.traceXAxis = this.traceData.allXData.slice(0, 6)
              this.traceData.distantData = this.traceData.allData.slice(0, 6)
              this.showCheckBtn.traceShow = true
            } else {
              this.showCheckBtn.traceShow = false
              this.traceData.traceXAxis = this.traceData.allXData
              this.traceData.distantData = this.traceData.allData
              // this.echartData = this.traceData
            }
          }
        }
      })
    },
    // 获取音视频数据
    _getStatistics() {
      this.barData.allXData = []
      this.barData.allBarData = []
      this.barData.allAudioData = []
      //  logDateBegin: 年-月-日 格式
      let param = {
        ouId: this.currenNode.id,
        logDateBegin: formatDate(this.currenNode.startTime),
        logDateEnd: formatDate(this.currenNode.endTime),
        onlyMedia: 1,
      }
      // 结束时间加一天
      param.logDateEnd = addDay(param.logDateEnd, 1)
      // 清空原数据
      this.barData.allXData = []
      this.barData.allAudioData = []
      this.barData.allBarData = []
      this.barData.xData = []
      this.barData.barEchartData = []
      this.barData.barAudioData = []
      // 查询接口
      getStatistics(param).then(res => {
        if (res.state === 0) {
          if (res.value && res.value.mediaMap) {
            // 按用户看，统计数据
            for (let ouId in res.value.mediaMap) {
              let userStatistics = res.value.mediaMap[ouId]
              for (let userId in userStatistics) {
                let userData = userStatistics[userId]
                for (let item of userData) {
                  if (item.type === 1) {
                    // item 判断为视频，往视频的数组添加数据
                    if (!this.userMap[userId + '']) {
                      this.userMap[userId + ''] = {}
                      this.userMap[userId + '']['video'] = 0
                      this.userMap[userId + '']['photo'] = 0
                    }
                    this.userMap[userId + '']['video'] = item.count
                  } else if (item.type === 2) {
                    // item 判断为照片，往照片的数组添加数据
                    if (!this.userMap[userId + '']) {
                      this.userMap[userId + ''] = {}
                    }
                    this.userMap[userId + '']['photo'] = item.count
                  }
                }
              }
            }
            let mediaArr = []
            for (let mediaUserId in this.userMap) {
              mediaArr.push(this.userMap[mediaUserId])
            }
            // 数据排序
            mediaArr.sort(function(a, b) {
              return b.video - a.video //b-a为降序
            })
            this.barData.allXData = []
            this.barData.allAudioData = []
            this.barData.allBarData = []
            for (let subMedia of mediaArr) {
              if ((subMedia.photo || subMedia.video) && (subMedia.photo > 0 || subMedia.video > 0)) {
                this.barData.allXData.push(subMedia.name)
                this.barData.allAudioData.push(subMedia.photo)
                if (mediaArr[0].video && mediaArr[0].video > 600) {
                  this.barData.allBarData.push((subMedia.video / 60).toFixed(2))
                  this.barData.videoUnit = this.$t('HoursVideo')
                } else {
                  this.barData.allBarData.push(subMedia.video)
                  this.barData.videoUnit = this.$t('MinutesVideo')
                }
              }
            }
            this.barData.xData = []
            this.barData.barEchartData = []
            this.barData.barAudioData = []
            if (this.showMore === false && this.barData.allXData.length > 6) {
              this.barData.xData = this.barData.allXData.slice(0, 6)
              this.barData.barEchartData = this.barData.allBarData.slice(0, 6)
              this.barData.barAudioData = this.barData.allAudioData.slice(0, 6)
              this.showCheckBtn.vedioShow = true
            } else {
              this.barData.xData = this.barData.allXData
              this.barData.barEchartData = this.barData.allBarData
              this.barData.barAudioData = this.barData.allAudioData
              this.echartData = this.barData
              this.showCheckBtn.vedioShow = false
            }
          }
        }
      })
    },
  },
  mounted() {
    this.attenceStaticShow = this.$refs.attendanceStatic.showMoreBtn
    this.flag2 = true
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'
.mainContent
  position relative
  height 100%
  .main_content
    height 100%
    .query-box
      display flex
      align-items: center
      position relative
      width calc(100% - 40px)
      margin 0 20px
      margin-top 20px
      padding 8px 0
      pointer-events: auto
      background: #fff;
      box-shadow: 0 0.01041667rem 0.03125rem 0 rgba(0,54,103,0.1);
      >>>.el-button--small
        padding: 10px 15px;/*no*/
      .date_search
        pointer-events: auto
      .serachBtn
        position absolute
        right 20px
        margin-left 10px
  .content_box
    width calc(100% - 20px)
    height 42.6%
    margin-left 20px
    margin-top 20px
    pointer-events: auto
    .record
      position relative
      .check_more
        position: absolute
        right: 15px
        top 50%
        transform: translate(0,-50%)
        text-align: center
        line-height: 28px
        padding: 0 7px
        border-radius: 2px
        font-weight: bold
        font-size: 14px
        border-radius: 4px;
        cursor pointer
      .attendance-time
        position: absolute
        right: 120px
        top 50%
        transform: translate(0,-50%)
        font-weight 600
        .time-title
          display: inline
        >>>.el-date-editor
          width 130px!important;/*no*/
          .el-input__inner
            height 30px
            line-height 30px
            padding 12px 5px 12px 0!important;
            padding-left 30px!important;/*no*/
        >>>.el-input__icon
          line-height 30px
    .title_box
      .new_title
        height 46px
        line-height 46px
        padding-left 56px
        font-size: 18px;
        font-weight: bold
    .healthy_alarm
      height: calc(100% - 50px)
      margin-left: 26px
  .content_box:first-child
    margin-top 0px
  .main-static
    height 98%
    width 70%
    float: left
  .alarm_statu
    height: calc(100% - 46px)
    .loading_img
      text-align: center
  .person_status
    height: calc(100% - 60px)
  .left-person
    float: left
    width calc(38% - 20px)
    height 100%
    padding-top 20px
  .equipment_num
    width 100%
    display flex
    margin 40px 8px 0
    .amount
      width 23.5%
      margin-right 4px
      text-align center
      .num
        width 100%
        height 112px
        line-height 112px
        font-size: 32px
        color: #0BFCFF
        bg-image-full('~@/icon/home/circular.png')
      .equip_name
        margin-top 10px
        color #fff
        font-size: 16px
        font-weight: bold
    .amount:last-child
      margin-right 0
  .right_li
    float: left
    width calc(62%)
    height 100%
    margin-left: 20px
    margin-top 20px
    .content_box
      margin-left 0
      width 100%
      height 42.6%
    .content_box:first-child
      margin-top 0px
  .person-static
    float: left
    height 86%
    width calc(30% - 40px)
.theme-dark
  .mainContent
    .main_content
      .query-box
        background: rgba(0,42,150,0.8);
        box-shadow: 0 0.01041667rem 0.03125rem 0 rgba(0,54,103,0.1);
</style>
